/**
 * Display model for the club stats season picker.
 * The backend supplies the seasons, their labels, and which one to preselect;
 * these helpers only shape that for a <select>.
 */

export function seasonPickerOptions(payload) {
  const seasons = Array.isArray(payload?.seasons) ? payload.seasons : [];
  return seasons
    .filter((row) => row && row.license_year)
    .map((row) => ({
      value: row.license_year,
      label: row.label || row.license_year,
      huntCount: Number(row.hunt_count) || 0,
      isCurrent: Boolean(row.is_current),
    }));
}

export function initialSeason(payload) {
  const options = seasonPickerOptions(payload);
  if (!options.length) return '';
  const preferred = payload?.default || payload?.current || '';
  return options.some((opt) => opt.value === preferred) ? preferred : options[0].value;
}

/** `2026-27 season · 12 sits` — the sub-line under the picker. */
export function seasonSummaryLabel(payload, season) {
  const match = seasonPickerOptions(payload).find((opt) => opt.value === season);
  if (!match) return '';
  const sits = `${match.huntCount} ${match.huntCount === 1 ? 'sit' : 'sits'}`;
  return `${match.label} season · ${sits}`;
}

/** Whether there is more than one season, i.e. whether a <select> earns its place. */
export function hasSeasonChoice(payload) {
  return seasonPickerOptions(payload).length > 1;
}

/**
 * Which season is on screen is always worth stating, even when it cannot be
 * changed — otherwise the tab looks like the old rolling-window view.
 */
export function hasSeasons(payload) {
  return seasonPickerOptions(payload).length > 0;
}
